import { useQuery } from '@apollo/client';
import useSearchState from './useSearchState';
import GET_ORGANIZATIONS from '../queries/organizationSearchQuery';

const PAGE_SIZE = 20;

export const useOrganizationSearch = () => {
  const { currentPage, searchText, searchChar, searchOHT, setSearchState, filters } =
    useSearchState({ includeFeiSearch: false });

  const {
    data: searchResult,
    loading,
    error
  } = useQuery(GET_ORGANIZATIONS, {
    variables: {
      filters,
      offset: (currentPage - 1) * PAGE_SIZE,
      limit: PAGE_SIZE
    }
  });

  const organizations = searchResult?.mddapOrganizationsFiltered || [];
  const totalCount = searchResult?.mddapOrganizationsFilteredCount || 0;

  return {
    organizations,
    totalCount,
    loading,
    error,
    searchState: {
      currentPage,
      searchText,
      searchChar,
      searchOHT,
      setSearchState
    }
  };
};
